import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const Pricing_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/pricing',
        iconClass: 'fas fa-circle-dollar',
        name: '::Menu:Pricing',
        layout: eLayoutType.application,
        requiredPolicy: 'Ldm.Pricing',
      },
    ]);
  };
}
